import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import SwipeableViews from 'react-swipeable-views';
import Tabs, {Tab} from 'material-ui/Tabs';
import Android from 'material-ui-icons/Android';
import Web from 'material-ui-icons/Web';
import Devices from 'material-ui-icons/Devices';
import Typography from 'material-ui/Typography';
import {withStyles} from 'material-ui/styles';
import AppleIcon from '../../../components/admin/analytics/icons/apple';

const styles = theme => ({
	root: {
		margin: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 24}px`
	},
	header: {
		marginBottom: theme.spacing.unit * 2,
		paddingLeft: '24px',
		paddingRight: '24px'
	}
});

const AnalyticsPage = props => (
	<div className={props.classes.root}>
		<Typography type="display2" className={props.classes.header}>
			Analytics
		</Typography>
		<Paper>
			<Tabs
				value={props.tabIndex}
				onChange={(event, value) => props.setTabIndex(value)}
				fullWidth
				indicatorColor="primary"
				textColor="primary"
			>
				<Tab icon={<Web/>} label="Web application"/>
				<Tab icon={<Android/>} label="Android"/>
				<Tab icon={<AppleIcon/>} label="iOS"/>
				<Tab icon={<Devices/>} label="Total"/>
			</Tabs>
			<SwipeableViews
				index={props.tabIndex}
				onChangeIndex={props.setTabIndex}
			>
				<div>
					Web application Analytics
				</div>
				<div>
					<Typography>
						Not implemented
					</Typography>
				</div>
				<div>
					<Typography>
						Not implemented
					</Typography>
				</div>
				<div>
					<Typography>
						Not implemented
					</Typography>
				</div>
			</SwipeableViews>
		</Paper>
	</div>
);

AnalyticsPage.propTypes = {
	classes: PropTypes.object.isRequired,
	tabIndex: PropTypes.number.isRequired,
	setTabIndex: PropTypes.func.isRequired
};

export default withStyles(styles)(AnalyticsPage);



// WEBPACK FOOTER //
// ./src/client/pages/admin/analytics/analytics.jsx